module.exports = __webpack_public_path__ + "img/achievement-box-feat-1.4daa3178.jpeg";